var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 18.3334C4.55862 18.3334 4.1347 18.1578 3.82214 17.8452C3.50958 17.5326 3.33398 17.1087 3.33398 16.6667V3.33336C3.33398 2.89133 3.50958 2.46741 3.82214 2.15484C4.1347 1.84228 4.55862 1.66669 5.00065 1.66669H11.6673C11.9311 1.66626 12.1924 1.71802 12.4361 1.819C12.6798 1.91997 12.9011 2.06816 13.0873 2.25502L16.0773 5.24502C16.2647 5.43128 16.4133 5.65281 16.5146 5.89682C16.6158 6.14084 16.6677 6.4025 16.6673 6.66669V16.6667C16.6673 17.1087 16.4917 17.5326 16.1792 17.8452C15.8666 18.1578 15.4427 18.3334 15.0007 18.3334H5.00065Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 1.66669V5.83335C11.666 6.05437 11.7538 6.26633 11.9101 6.42261C12.0664 6.57889 12.2783 6.66669 12.4993 6.66669H16.666",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15V10",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5L10 15L12.5 12.5",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.61161a02c65d05a1179bf887979fe8ca.svg";
export { ForwardRef as ReactComponent };